export const appName = 'Self Driving Resume';
